import '../css/welcome.css';
import logo from '../img/logo.png';
import background from '../img/bg.png';

const Login = () => {

    const vimeoUrl = "https://player.vimeo.com/video/762200849?autoplay=1&color&autopause=0&loop=1&muted=1&title=0&portrait=0&byline=0#t=";

    const bg = {backgroundImage: `url(${background})`}

    return <div className="welcome" style={bg}>

        <header className="welcome-header">
            <a href="https://www.learnylib.com">
                <img src={logo} alt="Logo" width={260} height={59}/>
            </a>
        </header>

        <main className="welcome-main">

            <div className="welcome-section welcome-left">

                <iframe 
                    className="welcome-video" 
                    frameBorder="0" 
                    allow="autoplay; fullscreen"
                    title="Video" 
                    src={vimeoUrl}
                ></iframe>

            </div>


            <div className="welcome-section welcome-top">

                <h1 className="welcome-title">Bienvenue sur LearnyLib !</h1>

                <div className="welcome-block">

                    <span className="welcome-em">Vous n'avez pas encore de compte LearnyLib ?</span>

                    <span>Finalisez votre inscription et accédez à votre formation en un clic :</span>
                
                    <a href="/app/register" >
                        <div className="welcome-button welcome-register">
                            <span>Créer mon compte</span>
                        </div>
                    </a>

                </div>

                <div className="welcome-block">

                    <span className="welcome-em">Vous êtes déjà membre Learnyib ?</span>

                    <span>Connectez-vous ci-dessous :</span>

                    <a href="/app/" >
                        <div className="welcome-button welcome-login">
                            <span>Me connecter</span>
                        </div>
                    </a>

                </div>

            </div>

        </main>

        <footer className="welcome-footer">

            <span>
                Nos formations uniques sont 100% en ligne et éligibles DPC, FIFPL, FAFPM et OPCO et 100% indemnisées.
                <br/>
                Formez-vous où et quand vous voulez.
            </span>

        </footer>

    </div>
}

export default Login;